import { render } from "./Authentication.vue?vue&type=template&id=6d828d4f&scoped=true&ts=true"
import script from "./Authentication.vue?vue&type=script&lang=ts"
export * from "./Authentication.vue?vue&type=script&lang=ts"

import "./Authentication.vue?vue&type=style&index=0&id=6d828d4f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d828d4f"]])

export default __exports__